// based on https://github.com/chandrahaswtw/ellipsis-tooltip-react-chan
import PropTypes from 'prop-types'
import { useState, useCallback, useMemo } from 'react'
import styled from 'styled-components'

import Tooltip from 'components/Shared/Tooltip/Index'

import { uniqueId } from 'utils/strings'

const WrappedElement = styled.div`
  display: inline-block;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font: inherit;
  box-sizing: border-box;
`

const EllipsisTooltip = (props) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const tid = useMemo(() => uniqueId(), [])

  const mouseEnterHandler = useCallback((e) => {
    if ((e.target.offsetWidth !== e.target.scrollWidth) && !showTooltip) {
      setShowTooltip(true)
    } else if ((e.target.offsetWidth === e.target.scrollWidth) && showTooltip) {
      setShowTooltip(false)
    }
  }, [showTooltip, setShowTooltip])

  const { children, place = 'top' } = props

  return (
    <>
      <WrappedElement
        data-tooltip-id={tid}
        onMouseEnter={mouseEnterHandler}
      >
        {children}
      </WrappedElement>

      {showTooltip && (
        <Tooltip id={tid} place={place}>
          {children}
        </Tooltip>
      )}
    </>
  )
}

EllipsisTooltip.propTypes = {
  children: PropTypes.node,
  place: PropTypes.string,
}

export default EllipsisTooltip
